module.exports = __webpack_public_path__ + "static/Creator 20 - @TomJSherlock-b7237051707f9ab872fd870d6d972097.png";